import { render, staticRenderFns } from "./pemateribmtk.vue?vue&type=template&id=f09fcb90"
import script from "./pemateribmtk.vue?vue&type=script&lang=js"
export * from "./pemateribmtk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports